import { __assign, __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useMemo, useRef, } from "react";
import { OutlineButton, PrimaryButton, SegmentedButton, TextButton, TonalButton, } from "./styles";
import { generateColorVariants } from "../../utils/functions";
import { Spinner } from "../Spinner";
import { useTheme } from "styled-components";
export var BUTTON_OPTIONS = {
    default: PrimaryButton,
    outlined: OutlineButton,
    tonal: TonalButton,
    text: TextButton,
    segmented: SegmentedButton,
};
export var Button = forwardRef(function Button(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? "default" : _b, _c = _a.size, size = _c === void 0 ? "large" : _c, icon = _a.icon, customColor = _a.customColor, color = _a.color, isLoading = _a.isLoading, isSelected = _a.isSelected, children = _a.children, triggerKey = _a.triggerKey, props = __rest(_a, ["variant", "size", "icon", "customColor", "color", "isLoading", "isSelected", "children", "triggerKey"]);
    var theme = useTheme();
    var ButtonToRender = BUTTON_OPTIONS[variant];
    var buttonRef = useRef(null);
    var colorVariants = useMemo(function () {
        return customColor
            ? generateColorVariants(customColor)
            : color
                ? theme.colors[color]
                : undefined;
    }, [customColor, color, theme.colors]);
    var textAndIcon = !!icon && !!children;
    useEffect(function () {
        if (!triggerKey)
            return;
        var handleKeyDown = function (event) {
            if (event.key === triggerKey) {
                if (!triggerKey || event.key !== triggerKey)
                    return;
                var activeElement = document.activeElement;
                var isInputFocused = activeElement instanceof HTMLInputElement ||
                    activeElement instanceof HTMLTextAreaElement;
                if (isInputFocused)
                    return;
                var button = buttonRef.current;
                if (!button)
                    return;
                var rect = button.getBoundingClientRect();
                var isVisible = rect.width > 0 && rect.height > 0;
                if (!isVisible)
                    return;
                var topElement = document.elementFromPoint(rect.left + rect.width / 2, rect.top + rect.height / 2);
                var isOnTop = topElement === button || button.contains(topElement);
                if (!isOnTop)
                    return;
                buttonRef.current.click();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return function () {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [triggerKey, ref]);
    return (_jsx(ButtonToRender, __assign({ ref: ref || buttonRef, "$hasIcon": !!icon, "$textAndIcon": textAndIcon, "$size": size, isSelected: isSelected, "$colorVariants": colorVariants }, props, { disabled: isLoading || props.disabled, children: isLoading ? (_jsx(Spinner, { color: theme.colors.neutral.light })) : (_jsxs(_Fragment, { children: [icon, children, triggerKey && " [".concat(triggerKey.toLocaleUpperCase(), "]")] })) })));
});
//# sourceMappingURL=index.js.map